export default __webpack_public_path__ + "static/media/pic3.084e84fc.jpg";